import Header from 'components/Header';
import Sidebar from 'components/Sidebar';

import { useAppSelector } from 'app/hooks';
import StatusBox from 'blocks/StatusBox';
import dayjs from 'dayjs';
import Paths from 'helper/paths';
import { useTranslation } from 'react-i18next';
import { dashboardUserInfoState } from 'store/dashboard/dasboardSlice';
import * as S from './withSideBar.styles';
const WithSidebar: React.FC = ({ children }): JSX.Element => {
  const { t } = useTranslation();
  const userInfo = useAppSelector(dashboardUserInfoState);
  return (
    <S.WithSideBar>
      <div>
        <Sidebar />
      </div>

      <S.WithSideBarContent>
        <Header />

        {dayjs(userInfo?.birthdate).isBefore(dayjs().add(-12, 'year').add(3, 'month')) &&
        userInfo?.type === 'CHD' &&
        (!userInfo.email || !userInfo.mobile) ? (
          <StatusBox
            type="success"
            text={t('layout.statusAlert.kidsAlert.text')}
            textBtn={t('layout.statusAlert.kidsAlert.btnText')}
            route={Paths.Profile.index().route}
          />
        ) : (
          ''
        )}
        <S.WithSideBarMain>{children}</S.WithSideBarMain>
      </S.WithSideBarContent>
    </S.WithSideBar>
  );
};

export default WithSidebar;
